import {AdType} from '~/modules/Creatives/models/Creative';

export enum TopCreativesFilterPeriod {
    TODAY = 0,
    YESTERDAY = 1,
    LAST_7_DAYS = 2,
    LAST_14_DAYS = 3,
    LAST_MONTH = 4
}

export const filterPeriods: { value: TopCreativesFilterPeriod; label: string }[] = [
    {value: TopCreativesFilterPeriod.TODAY, label: 'Today'},
    {value: TopCreativesFilterPeriod.YESTERDAY, label: 'Yesterday'},
    {value: TopCreativesFilterPeriod.LAST_7_DAYS, label: 'Last 7 days'},
    {value: TopCreativesFilterPeriod.LAST_14_DAYS, label: 'Last 14 days'},
    {value: TopCreativesFilterPeriod.LAST_MONTH, label: 'Last 30 days'}
];

export enum TopCreativesSortByOptions {
    IMPRESSION = 0,
    DATE = 1,
}


export const sortByOptions: { value: TopCreativesSortByOptions; label: string }[] = [
    {value: TopCreativesSortByOptions.IMPRESSION, label: 'By impression'},
    {value: TopCreativesSortByOptions.DATE, label: 'By date'}
];

export interface ITopCreativesFilter {
    adDomain?: string;
    adCategory?: AdType;
    bundle?: string;
    period: TopCreativesFilterPeriod;
    sortBy: TopCreativesSortByOptions;
    categories: string[];
}
